export class UpdateBackupPolicyResponse {
    'backupPolicy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicy",
            "baseName": "backupPolicy",
            "type": "BackupPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
